<template>
  <div class="ApprovalList">
    <div class="toolsBox">
      <el-button :disabled="selectRow.length===0" type="primary" plain @click="verifySelectedLesson"
                 v-show="permissionCode.has('research:approve:manager')"
      >快速审核
      </el-button>
    </div>
    <XTable
        ref="xTable"
        :api="getLessonVerifyResponseList"
        :state="lessonVerifyResponseList"
        :columns="columns"
        :loading="lessonVerifyResponseListLoading"
        :tableSize="tableSize"
        :layout="layout"
        :maxHeight="maxHeight"
        @select="handleSelectionChange"
        @select-all="handleSelectionChange"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import {APPROVAL_STATES, SERIES_STATES} from "@/utils/constants";
import DateUtil from "@/utils/formatDate";

export default {
  name: "ApprovalList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      selectRow: [],
      tableSize: "small",
      layout: "sizes, prev, pager, next"
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "lessonVerifyResponseListLoading",
      "lessonVerifyResponseList",
    ]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          type: "selection",
          width: 60,
        },
        {
          prop: "id",
          label: "课程编号",
        },
        {
          prop: "version",
          label: "版本号",
        },
        {
          prop: "name",
          label: "课程标题",
        },
        {
          prop: "classSubjectName",
          label: "系列名称",
        },
        {
          prop: "nickname",
          label: "老师",
        },
        {
          label: "课程时长",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDuration(scope.row.lessonDuration)}</span>
                </div>
            );
          },
        },
        {
          label: "上传时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.commitTime)}</span>
                </div>
            );
          },
        },
        {
          label: "素材数量",
          render(h, scope) {
            return (
                <div>
                  <span>{(scope.row && scope.row.materialsCount) || 0}</span>
                </div>
            );
          },
        },
        {
          label: "审核状态",
          render(h, scope) {
            return (
                <div>
                  <span>{APPROVAL_STATES[scope.row.states]}</span>
                </div>
            );
          },
        },
        {
          label: "上下架状态",
          render(h, scope) {
            return (
                <div>
                  <span>{SERIES_STATES[scope.row.deployStates]}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('research:approve:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 200,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleApproval(scope.row);
                      }}
                      disabled={scope.row.states !== 1}
                      size="mini"
                      type="primary"
                      plain
                  >
                    课程审核
                  </el-button>
                  {scope.row.deployStates === 0 && (
                      <el-button
                          onClick={() => {
                            self.handleDeployUp(scope.row);
                          }}
                          disabled={scope.row.states !== 2}
                          size="mini"
                          type="primary"
                          plain
                      >
                        上架
                      </el-button>
                  )}
                  {scope.row.deployStates === 1 && (
                      <el-button
                          onClick={() => {
                            self.handleDeployDown(scope.row);
                          }}
                          disabled={scope.row.states !== 2}
                          size="mini"
                          type="primary"
                          plain
                      >
                        下架
                      </el-button>
                  )}
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getLessonVerifyResponseList",
      "deployLesson",
      "verifyLessonVersion"
    ]),
    async verifySelectedLesson() {
      try {
        for (const item of this.selectRow) {
          await this.verifyLessonVersion({
            comment: "",
            lessonId: item.lessonId,
            version: item.version,
            states: 2,
          })
        }
      } finally {
        this.selectRow = [];
        this.getLessonVerifyResponseList({});
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.selectRow = val;
    },
    async handleApproval(row) {
      await this.$router.push(
          {
            name: "ApprovalCourse",
            params: {
              lessonId: this.$Base64.encode(row.lessonId),
              version: this.$Base64.encode(row.version),
            },
          },
          () => {
          }
      );
    },
    // 上架
    async handleDeployUp(row) {
      this.$confirm("请确认是否要上架该课程版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deployLesson({
              deployStates: 1,
              id: row.lessonId,
              version: row.version,
            });
            this.$message.success("操作成功");
            this.$refs.xTable.pageChange();
          })
          .catch(() => {
          });
    },
    // 下架
    async handleDeployDown(row) {
      this.$confirm("请确认是否要下架该课程版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deployLesson({
              deployStates: 0,
              id: row.lessonId,
              version: row.version,
            });
            this.$message.success("操作成功");
            this.$refs.xTable.pageChange();
          })
          .catch(() => {
          });
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
    //   根据时间戳计算上传时间
    formatDuration(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const obj = DateUtil.formatDuration(timestamp);
      return obj.minutes + ":" + obj.seconds;
    },
  },
};
</script>

<style lang="scss" scoped>
.toolsBox {
  text-align: right;
  margin-bottom: 20px;
}
</style>
